import * as angular from 'angular';

import { StateDeclaration } from '@uirouter/angularjs';

import { ComponentDefinition } from '../../../models';
import { IAuthorizationService } from '../../../services';
import { Roles } from '../../../common';

class DocumentationStateController implements angular.IComponentController {
    currentState: StateDeclaration;
    hasEditRole: boolean;

    static $inject = ['authorizationService'];

    constructor(private _authorizationService: IAuthorizationService) {
        this.hasEditRole = this._authorizationService.isInRoles(Roles.editDocumentationRoles);
    }
}

export const documentationState: ComponentDefinition = {
    componentId: 'wtDocumentationState',
    controller: DocumentationStateController,
    controllerAs: 'vm',
    template: require('./documentationState.component.html'),
    bindings: {
    }
};
